const divider = {
    styleOverrides: {
    root: {
      marginTop: 4,
      marginBottom: 4,
    },    
  },
};

export default divider;